import { createContext, useContext } from 'react';

// Keep context identity outside the map's Fast Refresh boundary so mounted
// cards stay connected when the map implementation is updated locally.
export const ProjectMapContext = createContext<(id: string) => void>(
  () => undefined,
);
export const SelectedProjectMapContext = createContext<string | undefined>(
  undefined,
);

export const useProjectListMap = () => useContext(ProjectMapContext);
export const useProjectListMapSelectedProjectId = () =>
  useContext(SelectedProjectMapContext);
